export default __webpack_public_path__ + "static/DavidOliver-cddbbe9d3784daea25bf0cb3f4efb756.jpg";